/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ResendUserInvite200ResponseResultOneOf1
 */
export interface ResendUserInvite200ResponseResultOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof ResendUserInvite200ResponseResultOneOf1
     */
    'reason': ResendUserInvite200ResponseResultOneOf1ReasonEnum;
}

export const ResendUserInvite200ResponseResultOneOf1ReasonEnum = {
    notFound: 'NOT_FOUND',
    alreadyRegistered: 'ALREADY_REGISTERED'
} as const;

export type ResendUserInvite200ResponseResultOneOf1ReasonEnum = typeof ResendUserInvite200ResponseResultOneOf1ReasonEnum[keyof typeof ResendUserInvite200ResponseResultOneOf1ReasonEnum];


